import React from "react";
import { SvgIcon, SvgIconProps } from "module/common/component/display";
export function ArrowDownIcon (props: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...props} data-testid="ArrowDownIcon" viewBox="0 0 24 24">
            <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
        </SvgIcon>
    )
}
        